import { defineComponent as _defineComponent } from 'vue'
import { watch } from "vue";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import { useStore } from "@/stores";
import DataSyncTask from "@/views/components/DataSyncTask.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const store = useStore();

watch(
  () => store.state.isLoading,
  (loading: any) => {
    if (loading === true) {
      NProgress.start();
    } else {
      NProgress.done();
    }
  }
);

return { __sfc: true,store, DataSyncTask }
}

})